/**
 * Correctif Kardone — WideBundle : sélection automatique d'un pack disponible
 * -----------------------------------------------------------------------
 * Problème (audit Kardone.fr, P-01) :
 *   L'app WideBundle pré-sélectionne toujours le pack marqué "preselected"
 *   dans son dashboard (en général le plus gros / le plus cher), sans jamais
 *   vérifier le stock des produits qui le composent. Si l'un des composants
 *   est en rupture (ex: Récepteur Laser R1), le pack reste affiché comme
 *   "sélectionné" mais le bouton "Ajouter au panier" est grisé avec la
 *   mention "Rupture de stock" — alors qu'un pack plus petit est disponible.
 *   Résultat : des ventes perdues sur des produits pourtant achetables.
 *
 * Correctif :
 *   Au chargement de la page, on regarde le pack pré-sélectionné par
 *   WideBundle. S'il n'est pas entièrement en stock, on parcourt les autres
 *   packs du plus gros au plus petit (wideBundle.offers, trié par
 *   offersPointer décroissant) et on sélectionne automatiquement le premier
 *   pack dont TOUS les produits sont disponibles (wideBundle.variantsInventory).
 *   La sélection se fait en simulant un clic sur l'option correspondante,
 *   ce qui réutilise telle quelle la logique native de WideBundle
 *   (wideBundle.changeSelectedOffer) pour mettre à jour prix, bouton
 *   d'achat, badges cadeaux, etc. Rien n'est modifié si le pack pré-
 *   sélectionné est déjà disponible, et le script ne fait rien sur les
 *   pages qui n'utilisent pas WideBundle.
 *
 *   Un petit style (voir layout/theme.liquid) masque brièvement le widget
 *   WideBundle le temps que ce script tranche, afin d'éviter d'afficher un
 *   flash du mauvais pack avant la correction. Un filet de sécurité révèle
 *   toujours le widget au bout de 10s maximum, même en cas de problème.
 *
 * Remarque :
 *   Ce correctif est un filet de sécurité côté vitrine. La vraie source du
 *   problème reste la configuration des packs dans le dashboard WideBundle
 *   (widebundle.com) : idéalement, pensez aussi à y désactiver ou masquer
 *   temporairement un pack dont un composant est en rupture prolongée.
 */
(function () {
  'use strict';

  function revealWidgets() {
    document.querySelectorAll('#new-form, .new-wb-form').forEach(function (el) {
      el.classList.add('wb-stock-fix-ready');
    });
  }

  function offerIsAvailable(offerGroup, inventory) {
    return offerGroup.every(function (component) {
      var variant = component.variants && component.variants[0];
      if (!variant) return false;
      var inv = inventory[variant.id];
      // Si on n'a pas l'info de stock pour ce variant, on ne bloque pas par précaution.
      if (!inv) return true;
      return Number(inv.inventory_quantity) > 0 && String(inv.add_to_cart_btn_enable) !== '0';
    });
  }

  function fixDefaultSelectionIfNeeded() {
    if (!window.wideBundle || !Array.isArray(window.wideBundle.offers) || !window.wideBundle.variantsInventory) {
      return;
    }

    var offers = window.wideBundle.offers;
    var inventory = window.wideBundle.variantsInventory;

    // Du pack le plus gros (offersPointer le plus élevé) au plus petit.
    var orderedIndexes = offers
      .map(function (_group, idx) { return idx; })
      .sort(function (a, b) { return offers[b][0].offersPointer - offers[a][0].offersPointer; });

    var selectedEl = document.querySelector('#new-form .new-form-option.selectedWB');
    var currentPointer = selectedEl ? selectedEl.getAttribute('data-offers-pointer') : null;
    var currentGroup = offers.find(function (g) { return String(g[0].offersPointer) === String(currentPointer); });

    // Le pack déjà sélectionné par défaut est disponible : on ne touche à rien.
    if (currentGroup && offerIsAvailable(currentGroup, inventory)) {
      return;
    }

    for (var i = 0; i < orderedIndexes.length; i++) {
      var group = offers[orderedIndexes[i]];
      if (offerIsAvailable(group, inventory)) {
        var pointer = group[0].offersPointer;
        var target = document.querySelector('#new-form .new-form-option[data-offers-pointer="' + pointer + '"]');
        if (target && !target.classList.contains('selectedWB')) {
          target.click(); // Déclenche wideBundle.changeSelectedOffer (prix, ATC, cadeaux...)
        }
        return;
      }
    }
    // Aucun pack entièrement disponible : on laisse WideBundle afficher son état "rupture de stock".
  }

  var attempts = 0;
  var maxAttempts = 30; // ~4.5s à 150ms d'intervalle
  var poll = setInterval(function () {
    attempts++;
    var widgetReady =
      document.querySelector('#new-form .new-form-option') &&
      window.wideBundle &&
      Array.isArray(window.wideBundle.offers) &&
      window.wideBundle.offers.length &&
      window.wideBundle.variantsInventory &&
      Object.keys(window.wideBundle.variantsInventory).length;

    if (widgetReady) {
      clearInterval(poll);
      fixDefaultSelectionIfNeeded();
      revealWidgets();
    } else if (attempts >= maxAttempts) {
      clearInterval(poll);
      revealWidgets(); // Filet de sécurité : ne jamais laisser le widget caché indéfiniment.
    }
  }, 150);

  // Second filet de sécurité, au cas où l'intervalle ci-dessus serait interrompu.
  setTimeout(revealWidgets, 10000);
})();
